import { fromJS } from 'immutable';
import {
  CLEAR_FLEETWORDREPORT_DATA,
  FETCH_EXCELREPORT_DATA,
  FETCH_EXCELREPORT_DATA_CLEAR,
  FETCH_EXCELREPORT_DATA_FAILURE,
  FETCH_EXCELREPORT_DATA_SUCCESS,
  FETCH_EXCELREPORT_EMAIL,
  FETCH_EXCELREPORT_EMAIL_SUCCESS,
  FETCH_FLEETREPORTCONFIG_DATA,
  FETCH_FLEETREPORTCONFIG_DATA_FAILURE,
  FETCH_FLEETREPORTCONFIG_DATA_SUCCESS,
  FETCH_FLEETREPORTSOC_DATA,
  FETCH_FLEETREPORTSOC_DATA_FAILURE,
  FETCH_FLEETREPORTSOC_DATA_SUCCESS,
  FETCH_FLEETREPORTTEMPERATURE_DATA,
  FETCH_FLEETREPORTTEMPERATURE_DATA_FAILURE,
  FETCH_FLEETREPORTTEMPERATURE_DATA_SUCCESS,
  FETCH_FLEETWORDREPORT_DATA,
  FETCH_FLEETWORDREPORT_DATA_FAILURE,
  FETCH_FLEETWORDREPORT_DATA_SUCCESS,
} from './constants';

const initialState = fromJS({
  loadingExcelReport: false,
  excelReportData: null,
  error: null,
  loadingExcelReportEmail: false,
  excelReportEmail: null,
  loadingFleetWordReport: false,
  fleetWordReportData: null,
  loadingFleetSOCReport: false,
  fleetSOCReportData: null,
  loadingFleetTemperatureReport: false,
  fleetTemperatureReportData: null,
  loadingFleetConfigReport: false,
  fleetConfigReportData: null,
});

export function reducerExcelReport(state = initialState, action) {
  switch (action.type) {
    case FETCH_EXCELREPORT_DATA:
      return state.set('loadingExcelReport', true).set('error', null);
    case FETCH_EXCELREPORT_DATA_SUCCESS:
      return state
        .set('loadingExcelReport', false)
        .set('excelReportData', action.excelReportData);
    case FETCH_EXCELREPORT_DATA_CLEAR:
      return state
        .set('loadingExcelReport', false)
        .set('excelReportData', null)
        .set('error', null);

    case FETCH_EXCELREPORT_EMAIL:
      return state.set('loadingExcelReportEmail', true).set('error', null);
    case FETCH_EXCELREPORT_EMAIL_SUCCESS:
      return state
        .set('loadingExcelReportEmail', false)
        .set('excelReportEmail', action.excelReportEmail);

    case FETCH_EXCELREPORT_DATA_FAILURE:
      return (
        state
          .set('loadingExcelReport', false)
          // .set("excelReportData", null)
          .set('error', action.error)
      );

    case FETCH_FLEETWORDREPORT_DATA:
      return state.set('loadingFleetWordReport', true).set('error', null);
    case FETCH_FLEETWORDREPORT_DATA_SUCCESS:
      return state
        .set('loadingFleetWordReport', false)
        .set('fleetWordReportData', action.fleetWordReport);

    case FETCH_FLEETWORDREPORT_DATA_FAILURE:
      return (
        state
          .set('loadingFleetWordReport', false)
          // .set("fleetWordReportData", null)
          .set('error', action.error)
      );
    // Fleet report SOC
    case FETCH_FLEETREPORTSOC_DATA:
      return state.set('loadingFleetSOCReport', true).set('error', null);
    case FETCH_FLEETREPORTSOC_DATA_SUCCESS:
      return state
        .set('loadingFleetSOCReport', false)
        .set('fleetSOCReportData', action.fleetWordReport);
    case FETCH_FLEETREPORTSOC_DATA_FAILURE:
      return (
        state
          .set('loadingFleetSOCReport', false)
          // .set("fleetSOCReportData", null)
          .set('error', action.error)
      );
    // Fleet report Temperature
    case FETCH_FLEETREPORTTEMPERATURE_DATA:
      return state
        .set('loadingFleetTemperatureReport', true)
        .set('error', null);
    case FETCH_FLEETREPORTTEMPERATURE_DATA_SUCCESS:
      return state
        .set('loadingFleetTemperatureReport', false)
        .set('fleetTemperatureReportData', action.fleetWordReport);
    case FETCH_FLEETREPORTTEMPERATURE_DATA_FAILURE:
      return (
        state
          .set('loadingFleetTemperatureReport', false)
          // .set("fleetTemperatureReportData", null)
          .set('error', action.error)
      );
    // Fleet report Config
    case FETCH_FLEETREPORTCONFIG_DATA:
      return state.set('loadingFleetConfigReport', true).set('error', null);
    case FETCH_FLEETREPORTCONFIG_DATA_SUCCESS:
      return state
        .set('loadingFleetConfigReport', false)
        .set('fleetConfigReportData', action.fleetWordReport);
    case FETCH_FLEETREPORTCONFIG_DATA_FAILURE:
      return (
        state
          .set('loadingFleetConfigReport', false)
          // .set("fleetConfigReportData", null)
          .set('error', action.error)
      );
    // Fleet word report clear data
    case CLEAR_FLEETWORDREPORT_DATA:
      return state.set('fleetWordReportData', null);

    default:
      return state;
  }
}
